import { useEffect, useRef } from "react";
import { TURNSTILE_SITE_KEY } from "../lib/api";

declare global {
  interface Window { turnstile?: { render: (el: HTMLElement, o: Record<string, unknown>) => string; reset: (id?: string) => void; remove: (id?: string) => void } }
}
let loading: Promise<void> | null = null;
function load() {
  if (window.turnstile) return Promise.resolve();
  loading ??= new Promise<void>((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true; s.onload = () => resolve(); s.onerror = () => { loading = null; reject(new Error("Could not load the bot check")); };
    document.head.appendChild(s);
  });
  return loading;
}

/** Cloudflare's free "are you human" check. Renders nothing when no site key is configured.
 *  `resetKey` changes after each attempt, because a token works only once. */
export function Turnstile({ onToken, resetKey }: { onToken: (t: string | null) => void; resetKey: number }) {
  const el = useRef<HTMLDivElement>(null);
  const id = useRef<string | null>(null);
  useEffect(() => {
    if (!TURNSTILE_SITE_KEY || !el.current) return;
    let alive = true;
    load().then(() => {
      if (!alive || !el.current || !window.turnstile) return;
      id.current = window.turnstile.render(el.current, {
        sitekey: TURNSTILE_SITE_KEY, theme: "light", appearance: "interaction-only",
        callback: (t: string) => onToken(t), "expired-callback": () => onToken(null), "error-callback": () => onToken(null),
      });
    }).catch(() => onToken(null));
    return () => { alive = false; if (id.current) window.turnstile?.remove(id.current); id.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => { if (resetKey && id.current) { onToken(null); window.turnstile?.reset(id.current); } }, [resetKey]); // eslint-disable-line
  return TURNSTILE_SITE_KEY ? <div ref={el} className="turnstile" /> : null;
}
